// extracted by mini-css-extract-plugin
export default {"logoLogin":"style_logoLogin__Uj7gD","logo":"style_logo__OwM8i"};